import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { CountersPage } from './-components/CountersPage';

const searchSchema = z.object({
  q: z.string().optional(),
  view: z.enum(['grid', 'table']).catch('grid'),
});

function CountersRoute() {
  useSetBreadcrumbs([{ label: 'Workspace' }, { label: 'Counters' }]);
  return <CountersPage />;
}

export const Route = createFileRoute('/counters/')({
  validateSearch: searchSchema,
  component: CountersRoute,
  errorComponent: ErrorComponent,
});
